import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { DummySidebar } from "pages/sideBar";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";
import { defaultPathConfigRepository } from "../pathConfig/PathConfigRepository";
import {
  MenuConfigModel,
  SidebarMenuConfigModel,
} from "./model/SidebarMenuConfigModel";

export interface IConfigRepository {
  getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>>;
}

export interface IMenuService {
  name: string;
  path: string;
  componentName: string;
  icon: string;
  subMenu?: MenuConfigModel[] | [];
}

export class SidebarMenuConfigRepository implements IConfigRepository {
  getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    return new Promise(async (resolve, reject) => {
      let menuConfig: MenuConfigModel[] = [];
      try {
        const res = await defaultPathConfigRepository?.configDetail(
          "b2c_cms_menu_items"
        );
        if (res) {
          let data = JSON.parse(res?.data?.config as string);
          let admin = data?.admin;
          let user = data?.user;

          switch (role) {
            case true:
              menuConfig = admin?.map((item: IMenuService) => {
                return new MenuConfigModel(
                  item?.name,
                  item?.path,
                  item?.componentName,
                  item?.icon,
                  item?.subMenu?.map((sub: any) => {
                    return new MenuConfigModel(
                      sub?.name,
                      sub?.path,
                      sub?.componentName,
                      sub?.icon
                    );
                  })
                );
              });
              break;
            case false:
              menuConfig = user?.map((item: IMenuService) => {
                return new MenuConfigModel(
                  item?.name,
                  item?.path,
                  item?.componentName,
                  item?.icon,
                  item?.subMenu?.map((sub: any) => {
                    return new MenuConfigModel(
                      sub?.name,
                      sub?.path,
                      sub?.componentName,
                      sub?.icon
                    );
                  })
                );
              });
              break;
            default:
              return undefined;
          }
        }
        // } else {
        //   getMessage(strings.GlobalMessage.InvalidMenuConfig, 4, "error");
        // }
      } catch (error) {
        getMessage(strings.GlobalMessage.InvalidMenuConfig, 4, "error");
        switch (role) {
          case true:
            menuConfig = DummySidebar?.admin?.map((item: IMenuService) => {
              return new MenuConfigModel(
                item?.name,
                item?.path,
                item?.componentName,
                item?.icon,
                item?.subMenu?.map((sub: any) => {
                  return new MenuConfigModel(
                    sub?.name,
                    sub?.path,
                    sub?.componentName,
                    sub?.icon
                  );
                })
              );
            });
            break;
          case false:
            menuConfig = DummySidebar?.user?.map((item: IMenuService) => {
              return new MenuConfigModel(
                item?.name,
                item?.path,
                item?.componentName,
                item?.icon,
                item?.subMenu?.map((sub: any) => {
                  return new MenuConfigModel(
                    sub?.name,
                    sub?.path,
                    sub?.componentName,
                    sub?.icon
                  );
                })
              );
            });
            break;
          default:
            return undefined;
        }
        console.log(error);
      }
      resolve(
        new BaseApiResponseModel<SidebarMenuConfigModel>(
          new SidebarMenuConfigModel(menuConfig),
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined
        )
      );
    });
  }
}

export default new SidebarMenuConfigRepository();
